import styled, { css } from 'styled-components';

import { inlineMediaQueryMixin } from '@zillow/constellation';

const displayCSS = (mediaProps: { display: string }) => css`
  display: ${mediaProps.display};
`;

export const StyledDisplayContainer = styled.div<{ display: { default?: string; md?: string; xxl_gte?: string } }>`
  ${inlineMediaQueryMixin('display', displayCSS)}
`;

export const StyledTextAlignCenter = styled.div`
  text-align: center;
`;
